import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import EmailIcon from '@mui/icons-material/Email'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import {
  Box,
  ButtonBase,
  CardContent,
  Fade,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { logoutRequest } from 'api/auth'
import { useAuthContext } from 'components/context/AuthProvider'
import ContactUsModal from 'components/modals/ContactUsModal'
import { LayoutHeader } from 'features/Layout/components/LayoutHeader/LayoutHeader'
import headerLogo from 'images/header_short.png'
import profileLogo from 'images/profile_logo.png'
import { MouseEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { useActions } from 'store/hooks'

export function AddSubscriptionHeader() {
  const { profileName, position, clearUserData } = useAuthContext()
  const { logout } = useActions()
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [isContactUsOpen, setContactUsOpen] = useState(false)

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const open = Boolean(anchorEl)

  const handleContactUs = () => {
    handleClose()
    setContactUsOpen(true)
  }

  const handleLogout = () => {
    void logoutRequest().finally(() => {
      logout()
      navigate(routes.signIn)
      clearUserData()
    })
  }

  return (
    <>
      <LayoutHeader>
        {isMobile ? (
          <img src={profileLogo} alt="Logo" style={{ height: 28, width: 'auto' }} />
        ) : (
          <img src={headerLogo} alt="Logo" />
        )}

        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonBase
            sx={{
              p: 0.25,
              bgcolor: open ? 'grey.300' : 'transparent',
              borderRadius: 1,
              '&:hover': { bgcolor: 'secondary.lighter' },
            }}
            onClick={handleOpen}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ p: 0.5 }}>
              <AccountCircleOutlinedIcon />
              <Typography variant="body1">{profileName}</Typography>
            </Stack>
          </ButtonBase>

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            elevation={1}
            anchorOrigin={{ vertical: 44, horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            TransitionComponent={Fade}
          >
            <Box sx={{ width: 290, minWidth: 240, maxWidth: 290 }}>
              <CardContent sx={{ px: 2.5, pt: 3 }}>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <AccountCircleOutlinedIcon />
                  <Stack>
                    <Typography variant="h6">{profileName}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {position}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>

              <List
                component="nav"
                sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: 'grey.500' } }}
              >
                <ListItemButton onClick={handleContactUs}>
                  <ListItemIcon>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText primary="Contact Us" />
                </ListItemButton>

                <ListItemButton onClick={handleLogout}>
                  <ListItemIcon>
                    <LogoutOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Logout" />
                </ListItemButton>
              </List>
            </Box>
          </Popover>
        </Box>
      </LayoutHeader>

      <ContactUsModal isOpen={isContactUsOpen} handleClose={() => setContactUsOpen(false)} />
    </>
  )
}
